import { Binding, BindRadioSelect, Spec } from 'vega';

export function isBindRadioSelect(
  b: Binding
): b is BindRadioSelect & { labels: string[] } {
  return 'input' in b && 'options' in b && b.input === 'radio';
}

export type ExtractedBinding = {
  bindingType: 'radio';
  signalName: string;
  initialOption: string;
  options: string[];
  fallbackLabels: string[];
};

export const extractBindingsFromSignals = (spec: Spec) => {
  // copy spec to avoid mutating the argument
  const specCopy = structuredClone(spec);

  const bindings: ExtractedBinding[] = [];

  if (specCopy.signals) {
    for (const signal of specCopy.signals) {
      // only collect supported bindings
      if (
        'bind' in signal &&
        signal.bind != null &&
        isBindRadioSelect(signal.bind)
      ) {
        bindings.push({
          bindingType: 'radio',
          fallbackLabels: signal.bind.labels,
          options: signal.bind.options,
          signalName: signal.name,
          initialOption: signal.value,
        });

        // delete all bindings regardless of input type
        delete signal.bind;
      }
    }
  }

  return { spec: specCopy, bindings };
};
